<tam-dialog class="intralinks-mapping-dialog" tid="intralink_mapping_dialog" [opened]="isOpen" [dialogWidth]="800"
    (keydown.esc)="onCancelClick()">
    <ng-template #title>
        <div class="title-box">
            <span>Mapping Configuration</span>
        </div>
        <div class="close-button-box">
            <smart-icon class="light small" name="close" (click)="onCancelClick()"></smart-icon>
        </div>
    </ng-template>
    <ng-template #body>
        <div class="content-container">
            <div class="content-left" loading-spin [isLoading]="!treeListOptions" [loadingSize]="'small'">
                <div class="tree-container" *ngIf="treeListOptions">
                    <aacl-tree-list [options]="treeListOptions"></aacl-tree-list>
                </div>
            </div>
            <div class="content-right">
                <div class="body" [ngStyle]="{'display': currentNode!==null?'flex':'none'}">
                    <div class="btn-group" *ngIf="!isWorkspace">
                        <button class="mapping-inherit" tam-button [tamType]="'primary'" [tamSize]="'normal'"
                            [tamLoading]="waitingForInherit" [disabled]="waitingForInherit" (click)="inheritClicked()"
                            title="Load values from direct parent folder">Load Values From Parent Folder</button>
                    </div>
                    <div class="scrollable">
                        <div class="fix-row" *ngIf="currentMapping">
                            <div class="content">
                                <div class="label">Entities:</div>
                                <div class="dropdown" *ngIf="!entityReloading">
                                    <multi-entity-dropdown [config]="entityConfig" [valueChangeSubject]="widgetSubject">
                                    </multi-entity-dropdown>
                                </div>
                            </div>
                            <div class="refresh-btn">
                                <div *ngIf="!isWorkspace">
                                    <smart-icon name="refresh" size="24" (click)="inheritEntities()"
                                        title="Load entities from all folders in path"></smart-icon>
                                </div>
                            </div>
                        </div>
                        <div class="fix-row" *ngIf="currentMapping">
                            <div class="content">
                                <div class="label">Note Type:</div>
                                <div class="dropdown">
                                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" #dropDownEl
                                        [data]="noteTypes" [(ngModel)]="currentMapping.noteType" [textField]="'name'"
                                        class="entity-type" [valueField]="'id'" [filterable]="true"
                                        (selectionChange)="selectionChange($event)"
                                        (filterChange)="handleFilter($event,dropDownEl)"
                                        (focus)="dropDownEl.toggle(true)" (mousedown)="$event.preventDefault()">
                                    </kendo-dropdownlist>
                                </div>
                            </div>
                            <!-- <div class="refresh-btn">
                                <smart-icon name="refresh" size="24" (click)="inheritNoteType()" title="Inherit from parent folder"></smart-icon>
                            </div> -->
                            <div class="placeholder"></div>
                        </div>
                        <tam-widget-list></tam-widget-list>
                    </div>
                </div>
                <div [ngStyle]="{'display': currentNode===null?'flex':'none'}" class="no-data">
                    No Folder Selected
                </div>
            </div>
        </div>
        <div class="footer">
            <span class="inherit">
                <!-- <label *ngIf="!isWorkspace" tam-checkbox [(ngModel)]="form.inherit">Automatically Submit Notes</label> -->
            </span>
            <button class="mapping-cancel" tam-button [tamType]="'tertiary'" [tamSize]="'normal'"
                (click)="onCancelClick()">Cancel</button>
            <button class="mapping-save" tam-button [tamType]="'primary'" [tamSize]="'normal'" [tamLoading]="isSaving"
                [disabled]="isSaving" (click)="onSaveClick()">Save</button>
        </div>
    </ng-template>
</tam-dialog>